
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'

@Component({
  components: {
    ModalWrapper,
    ImageViewer
  }
})
export default class AvatarUploader extends Vue {
  $refs: {
    croppie: any
  }

  croppieViewport = {
    width: 300,
    height: 300,
    type: 'circle'
  }

  croppieOuput = {
    width: 600,
    height: 600,
    format: 'base64'
  }

  image = null
  modalActive: boolean = false

  @Prop({ default: null }) avatarID

  @Prop({ default: false }) reloadImage

  @Prop({ default: false }) isLoading

  @Watch('image')
  openModal(file) {
    if (file) {
      this.modalActive = true
    }
  }

  get isEmpty() {
    return this.avatarID ? false : true
  }

  close() {
    this.image = null
    this.modalActive = false
  }

  emit(file) {
    const image = file
    const reader = new FileReader()
    reader.addEventListener('load', () => { this.$refs.croppie.bind({ url: reader.result }) })
    reader.readAsDataURL( image )
  }

  parseOutpout(base64) {
    return base64.split('base64,')[1]
  }

  submit() {
    this.$refs.croppie.result(this.croppieOuput, (output) => {
      this.$emit('submit', this.parseOutpout(output))
    })
    this.modalActive = false
  }
}
